import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-user-delete",
  templateUrl: "./med-icon-user-delete.component.html",
})
export class MedIconUserDeleteComponent extends SvgMixinComponent {}
